/* global jQuery, setTimeout, requestAnimationFrame */
jQuery(document).ready(function ($) {
    // Function to check if element is in viewport with offset
    function isElementInViewport(el, offset = 250) {
        const rect = el.getBoundingClientRect();
        const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;
        return rect.top <= windowHeight + offset;
    }

    // Function to handle scroll animation
    function handleScrollAnimation() {
        $('.animate-element').each(function () {
            if (isElementInViewport(this)) {
                $(this).addClass('start-animation');
            }
        });
    }

    // Immediately show elements above the fold without animation
    function initAboveFoldElements() {
        $('.animate-element').each(function () {
            if (isElementInViewport(this, 0)) {
                // Add class to disable transition and show final state immediately
                $(this).addClass('no-transition start-animation');
            }
        });

        // Force reflow, then remove no-transition class
        // This ensures the initial state is applied without animation
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                $('.animate-element.no-transition').removeClass('no-transition');
            });
        });
    }

    // Initialize above-fold elements immediately (no animation)
    initAboveFoldElements();

    // Bind scroll event with throttling for better performance
    let scrollTimeout;
    $(window).on('scroll', function () {
        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function () {
                handleScrollAnimation();
                scrollTimeout = null;
            }, 50);
        }
    });

    // Handle elements on initial load (for below-fold elements)
    setTimeout(handleScrollAnimation, 250);

    // Handle elements on dynamic content changes
    $(document).on('contentChanged', handleScrollAnimation);
});
